export default "__VITE_ASSET__b182eddc__"